import React, { useState, lazy } from 'react';
import {DndProvider} from 'react-dnd';
import Backend from 'react-dnd-html5-backend';
import ToggleSwitch from '../../common/ToggleSwitch.jsx';
import DataCaptureListV2 from "./DataCaptureListV2";
import withSuspense from '../../../helpers/withSuspense.jsx';
import LoadingIndicator from '../../common/loading_indicator.jsx';

const DataCaptureList = withSuspense(lazy(() => import('./DataCaptureList.jsx')), LoadingIndicator);

const FormDataCaptureList = ({phase, report, dispatch, showTitle = true, ...rest}) => {
  const [displayNewDataCaptureFunc, setDisplayNewDataCaptureFunc] = useState(!!phase.form_capture)

  return <DndProvider backend={Backend}>
    <div className='form-group'>
      <div>
        <label>{I18n.t('use_new_data_capture_functionality')}</label>
      </div>
      <ToggleSwitch
        isOn={displayNewDataCaptureFunc}
        handleToggle={() => setDisplayNewDataCaptureFunc(!displayNewDataCaptureFunc)}
      />
    </div>

    {displayNewDataCaptureFunc ?
      <DataCaptureListV2 {...{phase, report, dispatch, showTitle, initialConfigOptions: rest.initialConfigOptions}} /> :
      <DataCaptureList {...{phase, report, dispatch, showTitle, initialFormFields: rest.initialFormFields}} />
    }
  </DndProvider>
};

export default FormDataCaptureList;
